var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ExportMenu } from '@web/components/layout/ExportMenu/ExportMenu';
import Loading from '@web/components/layout/Loading';
import Table from '@web/components/layout/Table/Table';
import { widgetMetricCellBadgeDiff, widgetMetricCellInvisibleBadgeSlot, widgetMetricCellThreeColDiff, widgetMetricTableColMetricValueStyle, widgetMetricTableDiffTdClass, widgetMetricTableDurationSlashClass, widgetMetricTableFigureValueSpanHugClass, widgetMetricTablePairHeaderThAlignBodyTdClass, widgetMetricTablePrimaryLabelTdClass, widgetMetricTableValueCellInnerFitClass, widgetMetricTableValueTdClass } from '@web/components/layout/WidgetTable/widgetMetricCellClasses';
import { WidgetTitle } from '@web/components/layout/WidgetTitle/WidgetTitle';
import BadgeDiff from '@web/components/ui/Badge/BadgeDiff';
import { TablesDiffColorsConfig } from '@web/config';
import { trpc } from '@web/lib/trpc';
import { classNames, getIconByType, isAiButtonDisabled, isInsightsDataEmpty } from '@web/utility';
import { getDriveDocumentsActivitySearchFilters, navigateToDriveAdvancedSearch } from '@web/utility/chartNavigation';
import { useFilters } from '@web/utility/hooks/useFilters';
import { useNavigateTo } from '@web/utility/hooks/useNavigateTo';
import { DocumentTypeEnum, InsightTypeEnum } from '@workalizer/shared';
import { useTranslation } from 'react-i18next';
var DOCUMENT_TYPE_COLUMNS = [
    {
        key: 'document',
        type: DocumentTypeEnum.DOCUMENT,
        labelKey: 'reportTable.document'
    },
    {
        key: 'spreadsheet',
        type: DocumentTypeEnum.SPREADSHEET,
        labelKey: 'reportTable.spreadsheet'
    },
    {
        key: 'presentation',
        type: DocumentTypeEnum.PRESENTATION,
        labelKey: 'reportTable.presentation'
    },
    {
        key: 'other',
        type: DocumentTypeEnum.OTHER,
        labelKey: 'reportTable.other'
    }
];
var ROW_KEYS = [
    'created',
    'edited',
    'viewed',
    'shared',
    'comments',
    'suggestions'
];
var documentsActivityLabelCol = {
    width: '1%',
    minWidth: '6.5rem'
};
var documentsActivityMetricPair = [
    widgetMetricTableColMetricValueStyle,
    { width: '1%', minWidth: '6.5rem' }
];
var documentsActivityTableColgroup = __spreadArray(__spreadArray(__spreadArray(__spreadArray([
    documentsActivityLabelCol
], documentsActivityMetricPair, true), documentsActivityMetricPair, true), documentsActivityMetricPair, true), documentsActivityMetricPair, true);
var documentsActivityLabelHeaderClass = 'min-w-0 !text-left !pl-3';
var metricHeaderColspan = 2;
var headerMetricClass = widgetMetricTablePairHeaderThAlignBodyTdClass;
var pairMetricRowFitClass = 'inline-flex w-fit max-w-full min-w-0 flex-nowrap items-baseline justify-start gap-x-1 pl-0 pr-0';
var pairMetricDiffRowFitClass = 'inline-flex w-fit max-w-full min-w-0 flex-nowrap items-center justify-start gap-x-1 pl-0 pr-0';
var documentsActivityStackedDiffsClass = 'flex flex-col items-start gap-0.5';
var renderStackedCountDiff = function (periodDiff, teamDiff, showTeamDiff) { return (_jsxs("div", __assign({ className: documentsActivityStackedDiffsClass }, { children: [_jsx("div", __assign({ className: widgetMetricCellThreeColDiff }, { children: _jsx(BadgeDiff, { diffValue: periodDiff, customStyles: widgetMetricCellBadgeDiff, arrowColor: TablesDiffColorsConfig.GREEN }) })), showTeamDiff ? (_jsx("div", __assign({ className: widgetMetricCellThreeColDiff }, { children: teamDiff != null ? (_jsx(BadgeDiff, { diffValue: teamDiff, customStyles: widgetMetricCellBadgeDiff, arrowColor: TablesDiffColorsConfig.BLUE })) : (_jsx("div", { className: widgetMetricCellInvisibleBadgeSlot, "aria-hidden": true })) }))) : null] }))); };
var buildSingleMetricCells = function (idPrefix, metric, showTeamDiff, onNavigate) { return [
    {
        id: "".concat(idPrefix, "-value"),
        className: classNames(widgetMetricTableValueTdClass, onNavigate && 'cursor-pointer'),
        render: function () { return (_jsx("div", __assign({ className: classNames(widgetMetricTableValueCellInnerFitClass, onNavigate && 'cursor-pointer'), onClick: onNavigate }, { children: _jsx("span", __assign({ className: widgetMetricTableFigureValueSpanHugClass }, { children: metric.count })) }))); }
    },
    {
        id: "".concat(idPrefix, "-diff"),
        className: widgetMetricTableDiffTdClass,
        render: function () { return (_jsx("div", __assign({ className: "flex w-full min-w-0 justify-start pl-0 pr-0" }, { children: renderStackedCountDiff(metric.previous, metric.teamAverage, showTeamDiff) }))); }
    }
]; };
var buildPairMetricCells = function (idPrefix, metric, showTeamDiff, onLeftNavigate, onRightNavigate) { return [
    {
        id: "".concat(idPrefix, "-value"),
        className: classNames(widgetMetricTableValueTdClass, (onLeftNavigate || onRightNavigate) && 'cursor-pointer'),
        render: function () { return (_jsxs("div", __assign({ className: pairMetricRowFitClass }, { children: [_jsx("span", __assign({ className: classNames(widgetMetricTableFigureValueSpanHugClass, onLeftNavigate && 'cursor-pointer'), onClick: onLeftNavigate }, { children: metric.left.count })), _jsx("span", __assign({ className: widgetMetricTableDurationSlashClass, "aria-hidden": "true" }, { children: "/" })), _jsx("span", __assign({ className: classNames(widgetMetricTableFigureValueSpanHugClass, onRightNavigate && 'cursor-pointer'), onClick: onRightNavigate }, { children: metric.right.count }))] }))); }
    },
    {
        id: "".concat(idPrefix, "-diff"),
        className: widgetMetricTableDiffTdClass,
        render: function () { return (_jsx("div", __assign({ className: "flex w-full min-w-0 justify-start pl-0 pr-0" }, { children: _jsxs("div", __assign({ className: documentsActivityStackedDiffsClass }, { children: [_jsxs("div", __assign({ className: pairMetricDiffRowFitClass }, { children: [_jsx("div", __assign({ className: widgetMetricCellThreeColDiff }, { children: _jsx(BadgeDiff, { diffValue: metric.left.previous, customStyles: widgetMetricCellBadgeDiff, arrowColor: TablesDiffColorsConfig.GREEN }) })), _jsx("span", __assign({ className: widgetMetricTableDurationSlashClass, "aria-hidden": "true" }, { children: "/" })), _jsx("div", __assign({ className: widgetMetricCellThreeColDiff }, { children: _jsx(BadgeDiff, { diffValue: metric.right.previous, customStyles: widgetMetricCellBadgeDiff, arrowColor: TablesDiffColorsConfig.GREEN }) }))] })), showTeamDiff ? (_jsxs("div", __assign({ className: pairMetricDiffRowFitClass }, { children: [_jsx("div", __assign({ className: widgetMetricCellThreeColDiff }, { children: metric.left.teamAverage != null ? (_jsx(BadgeDiff, { diffValue: metric.left.teamAverage, customStyles: widgetMetricCellBadgeDiff, arrowColor: TablesDiffColorsConfig.BLUE })) : (_jsx("div", { className: widgetMetricCellInvisibleBadgeSlot, "aria-hidden": true })) })), _jsx("span", __assign({ className: widgetMetricTableDurationSlashClass, "aria-hidden": "true" }, { children: "/" })), _jsx("div", __assign({ className: widgetMetricCellThreeColDiff }, { children: metric.right.teamAverage != null ? (_jsx(BadgeDiff, { diffValue: metric.right.teamAverage, customStyles: widgetMetricCellBadgeDiff, arrowColor: TablesDiffColorsConfig.BLUE })) : (_jsx("div", { className: widgetMetricCellInvisibleBadgeSlot, "aria-hidden": true })) }))] }))) : null] })) }))); }
    }
]; };
var bindMetricNavigate = function (onNavigate, side) {
    if (!onNavigate) {
        return undefined;
    }
    return function () { return onNavigate(side); };
};
var buildMetricCells = function (idPrefix, metric, showTeamDiff, onNavigate) {
    return 'left' in metric
        ? buildPairMetricCells(idPrefix, metric, showTeamDiff, bindMetricNavigate(onNavigate, 'left'), bindMetricNavigate(onNavigate, 'right'))
        : buildSingleMetricCells(idPrefix, metric, showTeamDiff, bindMetricNavigate(onNavigate));
};
var getRowMetric = function (data, typeKey, rowKey) { return data[typeKey][rowKey]; };
var buildCsvRows = function (data, t, showTeamDiff) {
    return ROW_KEYS.flatMap(function (rowKey) {
        return DOCUMENT_TYPE_COLUMNS.map(function (_a) {
            var _b, _c, _d, _e, _f;
            var _g, _h, _j, _k;
            var key = _a.key, labelKey = _a.labelKey;
            var metric = getRowMetric(data, key, rowKey);
            var base = (_b = {},
                _b[t('reportTable.action')] = t("app.apps.drive.documentsActivity.rows.".concat(rowKey)),
                _b[t('reportTable.type')] = t(labelKey),
                _b);
            if ('left' in metric) {
                return __assign(__assign(__assign({}, base), (_c = {}, _c[t('app.apps.drive.summary.export.value')] = "".concat(metric.left.count, " / ").concat(metric.right.count), _c[t('app.apps.drive.summary.export.diff')] = "".concat(metric.left.previous.diffString, " / ").concat(metric.right.previous.diffString), _c)), (showTeamDiff && (_d = {},
                    _d["".concat(t('export.teamAverage'), " ").concat(t('app.apps.drive.summary.export.diff'))] = "".concat((_h = (_g = metric.left.teamAverage) === null || _g === void 0 ? void 0 : _g.diffString) !== null && _h !== void 0 ? _h : '', " / ").concat((_k = (_j = metric.right.teamAverage) === null || _j === void 0 ? void 0 : _j.diffString) !== null && _k !== void 0 ? _k : ''),
                    _d)));
            }
            return __assign(__assign(__assign({}, base), (_e = {}, _e[t('app.apps.drive.summary.export.value')] = metric.count, _e[t('app.apps.drive.summary.export.diff')] = metric.previous.diffString, _e)), (showTeamDiff &&
                metric.teamAverage && (_f = {},
                _f["".concat(t('export.teamAverage'), " ").concat(t('app.apps.drive.summary.export.diff'))] = metric.teamAverage.diffString,
                _f)));
        });
    });
};
function DriveDocumentsActivity() {
    var _this = this;
    var t = useTranslation().t;
    var _a = useFilters(), dateFrom = _a.dateFrom, dateTo = _a.dateTo, orgUnit = _a.orgUnit, user = _a.user;
    var navigateTo = useNavigateTo();
    var navigationScope = {
        navigateTo: navigateTo,
        dateFrom: dateFrom,
        dateTo: dateTo,
        userId: user,
        orgUnitId: orgUnit
    };
    var navigateToActivitySearch = function (documentType, rowKey, side) {
        navigateToDriveAdvancedSearch(navigationScope, __assign({ driveSearchType: documentType }, getDriveDocumentsActivitySearchFilters(rowKey, side)));
    };
    var _b = trpc.driveDocumentsActivity.useQuery({
        dateFrom: dateFrom,
        dateTo: dateTo,
        userId: user,
        orgUnitId: orgUnit
    }), data = _b.data, isLoading = _b.isLoading, refetch = _b.refetch;
    if (isLoading || !data) {
        return _jsx(Loading, {});
    }
    var showTeamDiff = Boolean(user);
    var columns = __spreadArray([
        {
            title: t('reportTable.action'),
            isVisible: true,
            className: documentsActivityLabelHeaderClass
        }
    ], DOCUMENT_TYPE_COLUMNS.map(function (_a) {
        var type = _a.type, labelKey = _a.labelKey;
        return ({
            title: (_jsxs("div", __assign({ className: "flex items-center gap-2" }, { children: [getIconByType(type, { width: '20', height: '20' }), _jsx("span", { children: t(labelKey) })] }))),
            isVisible: true,
            className: headerMetricClass,
            colspan: metricHeaderColspan
        });
    }), true);
    var tableData = ROW_KEYS.map(function (rowKey) { return __spreadArray([
        {
            id: "label-".concat(rowKey),
            className: "".concat(widgetMetricTablePrimaryLabelTdClass, " whitespace-normal"),
            render: function () { return (_jsx("div", __assign({ className: "min-w-0 max-w-full text-sm font-medium text-gray-900 break-words" }, { children: t("app.apps.drive.documentsActivity.rows.".concat(rowKey)) }))); }
        }
    ], DOCUMENT_TYPE_COLUMNS.flatMap(function (_a) {
        var key = _a.key, type = _a.type;
        return buildMetricCells("".concat(rowKey, "-").concat(key), getRowMetric(data, key, rowKey), showTeamDiff, function (side) { return navigateToActivitySearch(type, rowKey, side); });
    }), true); });
    return (_jsxs("div", __assign({ className: "w-full" }, { children: [_jsx(WidgetTitle, { title: t('app.apps.drive.documentsActivity.title'), description: "widgetTitleDescriptions.apps.driveDocumentsActivity", insightType: InsightTypeEnum.driveDocumentsActivity, insightsData: data, refetch: refetch, csvExport: _jsx(ExportMenu, { fileName: t('app.apps.drive.documentsActivity.title'), onExportHandler: function () { return __awaiter(_this, void 0, void 0, function () { return __generator(this, function (_a) {
                        return [2 /*return*/, buildCsvRows(data, t, showTeamDiff)];
                    }); }); }, disabled: isAiButtonDisabled(data) }) }), _jsx(Table, { columns: columns, data: isInsightsDataEmpty(data) ? [] : tableData, columnColStyles: documentsActivityTableColgroup, tableClassName: "table-auto w-full", rowClassName: "[&>td]:!align-middle" })] })));
}
export default DriveDocumentsActivity;
